import { render, staticRenderFns } from "./DependentsDropdown.vue?vue&type=template&id=516af801"
import script from "./DependentsDropdown.vue?vue&type=script&lang=js"
export * from "./DependentsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports